import { parse } from 'json2csv';

/**
 * Converts JSON to CSV format and triggers a browser download
 *
 * @param {function} getDataRows - a function that will return a valid JSON
 * @param {string} fileName - target file name of the download
 */
export const downloadCSV = (rows, fileName = 'data.csv') => {
  if (rows && rows.length) {
    const csvFileData = parse(rows, { includeEmptyRows: true });
    let downloadLink = document.createElement('a');
    const csvBlob = new Blob([csvFileData], {
      type: 'text/csv;charset=utf-8;'
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(csvBlob, `${fileName}.csv`);
    } else {
      const fileUrl = URL.createObjectURL(csvBlob);
      downloadLink.href = fileUrl;
      downloadLink.download = fileName; //Name the file here
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
    }
  }
};
